import DataStore from '@/engine/stores/data-store';

class WorkTrackerAdminItemDataStore extends DataStore {

}

export default new WorkTrackerAdminItemDataStore();
